import { rei } from "@/services/api"

class RelatorioSipetService {
  static getPdfRelatorio (busca) {
    return rei.post(`relatorio-sipet`, busca, { responseType: 'arraybuffer' }).then((res) => {
      return res
    })
  }
  static exportCsvRelatorio (params) {
    return rei.get(`export/relatorio-sipet`, {params}).then((res) => {
      return res
    })
  }
  static getItensRelatorio (params) {
    return rei.get(`listagem-relatorio-sipet`, {params}).then((res) => {
      return res
    })
  }
}

export default RelatorioSipetService
